import React from "react";

const DemoModal = ({ 
  showModal, 
  setShowModal, 
  formData, 
  handleChange, 
  handleModalSubmit, 
  submitError 
}) => {
  if (!showModal) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4 z-50">
      <div className="bg-gray-900 p-8 rounded-2xl max-w-md w-full mx-4 border border-gray-700">
        <h3 className="text-2xl font-bold mb-6 text-center">Get Started Today</h3>
        <form onSubmit={handleModalSubmit} className="space-y-4">
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            required
            className="w-full px-4 py-3 bg-gray-800/50 border border-gray-600/50 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-[hsl(30,100%,85%)]/50"
          />
          <input
            type="text"
            name="companyName"
            placeholder="Company Name"
            value={formData.companyName}
            onChange={handleChange}
            required
            className="w-full px-4 py-3 bg-gray-800/50 border border-gray-600/50 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-[hsl(30,100%,85%)]/50"
          />
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            required
            className="w-full px-4 py-3 bg-gray-800/50 border border-gray-600/50 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-[hsl(30,100%,85%)]/50"
          />
          <textarea
            name="message"
            placeholder="Tell us about your business"
            value={formData.message}
            onChange={handleChange}
            required
            rows="4"
            className="w-full px-4 py-3 bg-gray-800/50 border border-gray-600/50 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-[hsl(30,100%,85%)]/50"
          />
          {submitError && (
            <div className="text-red-500 text-sm text-center bg-red-500/10 p-3 rounded-lg">
              {submitError}
            </div>
          )}
          <div className="flex gap-4">
            <button
              type="button"
              onClick={() => setShowModal(false)}
              className="flex-1 px-6 py-3 bg-gray-700 rounded-lg hover:bg-gray-600 transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="flex-1 px-6 py-3 bg-[hsl(30,100%,85%)] text-black rounded-lg hover:bg-white transition-colors font-medium"
            >
              Get Started
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default DemoModal; 